import React from "react";
import { Grid } from "@material-ui/core";
import { useCurrentTradesReportFilter } from "../../../data/reports/dailyTrade/hooks/useTradesReportFilter";
import { DateInput } from "../../components/common/DateInput";
import { isValidDate } from "../../../core/util/functions";
import { LocalizationContext } from "../../../core/localization/Localization";

export const DailyTradesReportFilter: React.FunctionComponent = () => {
	const [filter, setReportDate] = useCurrentTradesReportFilter();
	const { getString } = React.useContext(LocalizationContext);

	return (
		<Grid container alignItems="center" >
			<Grid item>
				<DateInput
					clearable={false}
					label={getString("dailyTradeReportReportDate")}
					value={filter?.reportDate || null}
					onChange={date => {
						if (isValidDate(date)) {
							setReportDate(date.toISOString());
						}
					}}
				/>
			</Grid>
		</Grid>
	);
};
